import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { APIURL, IMAGE_FULL_URL, IMAGE_NOPHOTO_URL, IMAGE_UPLOAD_ERROR } from '../../config/config'
import axios from 'axios'

class MaintenanceCenterFile extends Component{
  constructor (props) {
    super(props);
    // center_file , center_key
    this.state = {
      center_file: '',
      center_key: ''
    }

    this.saveCarImage = this.saveCarImage.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);

  }

  componentDidMount () {
    let center = this.props.center
    this.setState({
      center_file: center.center_file === 'nophoto.png' ? IMAGE_NOPHOTO_URL: center.center_file,
      center_key: center.center_key
    })
  }

  saveCarImage(e,urlImage){
    e.preventDefault();
    let a = document.createElement('a');
    a.href = urlImage;
    a.target = '_blank';
    a.download = urlImage;
    a.click();
    a.remove();
    return false;
  }

  handleUploadFile (event){
    const center = this.props.center
    const input_file_name = event.target.name
    let center_key = ''

    const that = this;
    const center_id = center.center_id

    // input_file_name= slip_image2
    if (input_file_name === 'file_image1'){
      center_key = this.state.center_key === null ? '' : this.state.center_key
      this.refs.img_file_image1.src='img/loading.gif'
      this.refs.img_file_image1.height=32
    }

    const data = new FormData();
    data.append('uploads', event.target.files[0], event.target.files[0].name)
    data.append('center_id', center_id)
    data.append('center_key', center_key)
    data.append('center_file', input_file_name)

    axios.put(APIURL+'/center/image/'+center_id, data).then(function(res) {
      const resData = res.data;
      const filename = resData.image;
      const image_key = resData.image_key;
      let image_url = ''

      if(resData.image === undefined) {
        image_url = IMAGE_UPLOAD_ERROR
      } else if (resData.image === 'uploaderror') {
        image_url = IMAGE_UPLOAD_ERROR
      } else {
        image_url = filename
      }

      if( input_file_name === 'file_image1'){
        that.setState({
          center_file: image_url,
          center_key: image_key,
        }, () =>  {
          // close && reload data
          that.props.onToggle()
          that.props.onReload()
        })

      }
    })

  }

  render () {
    const {
      width,
      center
    } = this.props

    let image_url = ''

    if(center.center_file === 'nophoto.png') {
      image_url = IMAGE_NOPHOTO_URL
    } else {
      // check https
      if (center.center_file !== null && center.center_file !== undefined) {
        if (center.center_file.includes('https')) {
          image_url = center.center_file
        }else{
          image_url = IMAGE_FULL_URL + center.center_file
        }
      }else{
        image_url = IMAGE_NOPHOTO_URL
      }
    }


    return (
      <Modal isOpen={this.props.toggle} toggle={this.props.onToggle}
             className={'modal-xs'}
             style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}
      >
        <ModalHeader toggle={this.props.onToggle}>แนบไฟล์ภาพ</ModalHeader>
        <ModalBody>
          <div className="row p-5">

            <div className="form-group col-sm-5"></div>

            <div className="form-group col-sm-5">
              <label htmlFor="name">1) แนบไฟล์ภาพ
                &nbsp;
                <a rel="noopener noreferrer"
                   href={image_url}
                   target="_blank"
                   onClick={(e)=>this.saveCarImage(e, image_url)}
                   className={image_url===IMAGE_NOPHOTO_URL? 'hidden' : ''}>
                  <span>Download</span>
                </a>
              </label>
              <div style={styles.fileInputWrapper} >

                <button style={styles.btnFileInput}>
                  <img src={this.state.center_file}
                       style={styles.btnFileInputImage}
                       ref="img_file_image1"
                       alt="เอกสาร 1"
                  />
                </button>
                <input
                  style={styles.fileInput}
                  type="file"
                  name="file_image1"
                  onChange={this.handleUploadFile}
                />
              </div>
            </div>

          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onToggle}>ยกเลิก</Button>
        </ModalFooter>
      </Modal>
    )
  }
}


const styles = {
  bottomLine: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
  },
  fileInputWrapper: {
    position: 'relative',
    overflow: 'hidden',
    height: 180,
    width: 200,
  },
  btnFileInput: {
    height: 180,
    width: 200,
    display: 'inline-block',
    backgroundColor: "#D2DDE2",
    backgroundImage: "linear-gradient(to bottom, #D2DDE2, #FCF8FF)",
    backgroundRepeat: "repeat-x",
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)"
  },
  btnFileInputImage:{
    position: 'absolute',
    top: 0,
    left: 0,
    height: 180,
    width: 200,
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    right: 0,
    opacity: 0,
    height: 180,
    width: 200,
    cursor: 'pointer'
  }
}

export default MaintenanceCenterFile